module.exports = __webpack_public_path__ + "static/media/newsfeed-dark.b628ca47.svg";